import { Outlet, useNavigate } from 'react-router-dom'
import { Page } from './page.tsx'
import React, { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../../redux/hooks.ts'
import {
  reloadThemeStyle,
  selectTheme,
} from '../../features/setting/setting.slice.ts'
import { Theme } from '../../features/setting/setting.def.ts'
import {
  getDarkComponents,
  getDarkToken,
  getLightComponents,
  getLightToken,
} from '../../styles/antd/config-token/token.ts'
import {
  requestUserInfo,
  selectUser,
  setUserInfo,
} from '../../features/user/user.slice.ts'
import { useLazyGetUserInfoQuery } from '../../apis/auth/auth.api.ts'
import { IdeyaSpinner } from '../components/ideya-spinner.tsx'
import ConfigProvider from 'antd/es/config-provider/index'
import theme from 'antd/es/theme/index'
import {
  getDarkComponents1ppon,
  getDarkToken1ppon,
  getLightComponents1ppon,
  getLightToken1ppon,
} from '../../styles/antd/config-token/ippon-token.ts'
import { isIppon } from '../../utils/helpers.ts'
import { useAuth0 } from '@auth0/auth0-react'

export const IpponRoot: React.FC = () => {
  const navigate = useNavigate()
  const colorTheme = useAppSelector(selectTheme)
  const user = useAppSelector(selectUser)
  const dispatch = useAppDispatch()
  const [getUserInfo, { data: userInfoData, isLoading, isError }] =
    useLazyGetUserInfoQuery()
  const {
    loginWithRedirect,
    isAuthenticated,
    isLoading: isLoadingAuth0,
  } = useAuth0()

  useEffect(() => {
    if (!isAuthenticated && !isLoadingAuth0) {
      loginWithRedirect()
    }
  }, [isAuthenticated, isLoadingAuth0, loginWithRedirect])

  // Fetch user info on mount if user is not present
  useEffect(() => {
    if (!user) {
      dispatch(requestUserInfo())
      getUserInfo()
    } else if (!isLoading) {
      navigate('/idea')
    }
  }, [user, dispatch, getUserInfo, isLoading, navigate])

  useEffect(() => {
    if (userInfoData) {
      dispatch(setUserInfo(userInfoData.data))
    }
  }, [userInfoData, dispatch])

  useEffect(() => {
    document.documentElement.setAttribute(
      'data-theme',
      colorTheme === Theme.Dark ? Theme.Dark : Theme.Light
    )
    reloadThemeStyle()
  }, [colorTheme])

  useEffect(() => {
    if (!user && !isLoading && isError) {
      navigate('/login')
    }
  }, [user, isLoading, isError, navigate])

  if (!user || isLoading) {
    return (
      <div
        style={{
          width: '100%',
          height: '50vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <IdeyaSpinner />
      </div>
    )
  }

  const token = isIppon
    ? colorTheme === Theme.Dark
      ? getDarkToken1ppon()
      : getLightToken1ppon()
    : colorTheme === Theme.Dark
      ? getDarkToken()
      : getLightToken()

  const components = isIppon
    ? colorTheme === Theme.Dark
      ? getDarkComponents1ppon()
      : getLightComponents1ppon()
    : colorTheme === Theme.Dark
      ? getDarkComponents()
      : getLightComponents()

  return (
    <ConfigProvider
      theme={{
        token,
        components,
        algorithm:
          colorTheme === Theme.Dark
            ? theme.darkAlgorithm
            : theme.defaultAlgorithm,
      }}
    >
      <div className={'w-full h-full'}>
        <Page userInfo={user}>
          <Outlet />
        </Page>
      </div>
    </ConfigProvider>
  )
}
